export enum RevaluationType {
  Revaluation = 'REVALUATION',
  InitialInvestment = 'INITIAL_INVESTMENT',
}

export type RevaluationPrefix = 'revaluations' | 'newRevaluations';

export enum RevaluationTransactionType {
  CompanyRevaluationUp = 'companyRevaluationUp',
  CompanyRevaluationDown = 'companyRevaluationDown',
}
